import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { PlusCircleIcon, XCircleIcon } from '@heroicons/react/outline'
import { errorModal, questionModal } from "../../../../../../utils";
import { InputText, NormalButton, NormalButton2, SelectOption } from "../../../../../../ui";


const linderos = [{ lindero: "Norte" }, { lindero: "Sur" }, { lindero: "Oriente" }, { lindero: "Poniente" }]

export const RegistroFase5Colindancia = ({ tab, setTab, formulario, setFormulario }) => {
  const [contador, setContador] = useState(1);
  const [lindero, setLindero] = useState([]);
  const { register, handleSubmit, formState: { errors }, unregister, setValue } = useForm();

  useEffect(() => {
    if (formulario.colindancia) {
      if (formulario.colindancia.length > 0) {
        let arregloAux = [];
        for (let i = 0; i < formulario.colindancia.length; i++) {
          arregloAux.push({ numero: i + 1 });
          setValue(`lindero${i + 1}`, formulario.colindancia[i].lindero);
          setValue(`colindancia_registral${i + 1}`, formulario.colindancia[i].colindancia_registral)
        }
        setLindero(arregloAux);
        setContador(formulario.colindancia.length + 1);
      }
    }
    // eslint-disable-next-line
  }, [])


  const agregarLindero = () => {
    setLindero([...lindero, { numero: contador }]);
    setContador(contador + 1);

  }

  const quitarLindero = (item, index) => {
    if (item.numero === (contador - 1)) {
      let auxLindero = [...lindero];
      auxLindero.splice(index, 1);
      setLindero(auxLindero);
      unregister(`lindero${item.numero}`);
      unregister(`colindancia_registral${item.numero}`);
      setContador(contador - 1)
    } else {
      errorModal('existen linderos posteriores a este');
    }
  }

  const almacenarDatosFormulario = (data) => {
    if (contador === 1) {
      errorModal('Crear medidas y colindancias es obligatorio')
    } else {
      let colindancia = [];
      for (let i = 1; i < contador; i++) {
        colindancia.push({
          lindero: data[`lindero${i}`],
          colindancia_registral: data[`colindancia_registral${i}`]
        })
      }
      setFormulario({ ...formulario, colindancia });
      setTab(tab + 1);
    }
  }

  return (
    <form onSubmit={handleSubmit((data) => almacenarDatosFormulario(data))}>
      <div className="flex flex-wrap">
        <div className='w-full pt-5 mb-4 border-b-8 border-gray-300 rounded-md flex items-center justify-center'>

          <label className=' text-center block text-2xl font-bold text-gray-400'>
            Medidas y Colindancias
          </label>
          <button type='button' className='h-6 w-6 text-green-600 hover:-translate-y-1 hover:scale-110 ease-in-out delay-150 duration-100' onClick={agregarLindero}>
            <PlusCircleIcon />
          </button>
        </div>

        {
          lindero.map((item, index) =>
            <div key={item.numero} className='my-4 px-1 pb-4 w-full  flex flex-wrap' >

              <div className='w-full bg-gray-400 rounded-t-xl flex items-center justify-center'>
                <label className='text-center block text-xl font-bold text-white'>
                  Lindero y Colindancia Registral
                </label>
                <button type='button' className='h-6 w-6 ml-5 text-red-600 hover:-translate-y-1 hover:scale-110 ease-in-out delay-150 duration-100' onClick={() => questionModal('Eliminar', 'Esta Seguro de Eliminar', () => { quitarLindero(item, index) })}>
                  <XCircleIcon />
                </button>
              </div>

              <div className='w-full md:flex border-x-4 border-b-4 border-gray-400 rounded-b-xl shadow-lg p-2'>
                <div className='md:mr-2 md:w-1/2'>
                  <SelectOption nameLabel='Lindero' register={register} name={`lindero${item.numero}`} message='El lindero es requerido' errors={errors} array={linderos} valueOption='lindero' nameOption='lindero' />
                </div>
                <div className='md:ml-2 md:w-1/2'>
                  <InputText nameLabel='Colindancia registral' register={register} name={`colindancia_registral${item.numero}`} message="La colindancia registral es requerida" errors={errors} Placeholder="Ej. 36.70 metros con Ruta Nacional" />
                </div>
              </div>
            </div>
          )
        }

        <div className="w-full mx-3 mt-5 text-center flex justify-end">
          <NormalButton funcion={() => setTab(tab - 1)} bgColor='bg-red-700' bgText='text-white font-semibold' hoverColor='hover:bg-red-800' dimension="mr-1 px-1 sm:px-6 py-2 rounded-md cursor-pointer" title={
            <div className="flex">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
              Anterior
            </div>
          } />

          <NormalButton2 typeButton="submit" bgColor='bg-blue-900' bgText='text-white font-semibold' hoverColor='hover:bg-blue-800' dimension="mr-1 px-1 sm:px-6 py-2 rounded-md cursor-pointer" title={
            <div className="flex">
              Siguiente
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </div>
          } />
        </div>
      </div>
    </form>
  )
}
